var App = App || {};

App.SmartAppBanner = (function ($) {
    'use strict';

    function init() {
        
        // Smart app banner
        new SmartBanner({
            daysHidden: 15,
            daysReminder: 90,
            appStoreLanguage: 'us',
            title: 'Ameris Bank',
            author: 'Ameris Bank',
            button: 'VIEW',
            store: {
                ios: 'On the App Store',
                android: 'In Google Play'
            },
            price: {
                ios: 'FREE',
                android: 'FREE'
            }
        });

        var $smartbanner = $(".smartbanner"),
            $smartbannerButton = $smartbanner.find(".smartbanner-button");

        $smartbanner.prependTo("section.navigation.mobile");
        $smartbannerButton.addClass("btn btn-sm btn-primary btn-no-arrow");
        
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.SmartAppBanner.init();
});